<div class="modal-header">
  <h4 class="modal-title pull-left" *ngIf="!isNewCompetence">Modification de la compétence</h4>
  <h4 class="modal-title pull-left" *ngIf="isNewCompetence">Nouvelle compétence</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" onkeydown="return event.key != 'Enter';" autocomplete="off" role="presentation">
  <div class="modal-body">

    <div class="form-group required">
      <label class="control-label" for="numero">Num&eacute;ro de comp&eacute;tence</label>
      <input type="number" class="form-control" id="numero" placeholder="" formControlName="numero" [(ngModel)]="competence.numero"
             (focusout)="verifierSiNumeroExiste($event.target.value)"
             (focus)="effacerMessageErreur();" />
    </div>
    <p [hidden]="!afficherMessageNumero"
       class="bg-danger">Ce num&eacute;ro de comp&eacute;tence existe d&eacute;j&agrave; pour ce programme!</p>

    <div class="form-group required">
      <label class="control-label" for="code">Code</label>
      <div style="display:flex;">
        <input type="text" class="form-control format-code" id="code" placeholder=""
               (input)="verifierSiCodeValide($event.target.value)"
               formControlName="code"
               [(ngModel)]="competence.code" />
        <label style="color: #0c5460; margin-top: 5px; margin-left: 10px;">Formats autoris&eacute;s : « AEP 000-000 » ou « 000-000 » ou « 000X »</label>
      </div>
    </div>
    <p [hidden]="!afficherMessage"
       class="bg-danger">Cette comp&eacute;tence existe d&eacute;j&agrave; pour ce programme!</p>

    <div class="form-group required">
      <label class="control-label" for="enonce">&Eacute;nonc&eacute; de comp&eacute;tence</label>
      <input type="text" class="form-control" id="enonce" placeholder="" formControlName="enonce" [(ngModel)]="competence.enonce" />
    </div>

  </div>

  <div class="modal-footer">
    <!--<button *ngIf="!isNewCompetence" type="button" class="btn btn-danger" style="position:absolute; left:11px;"
            [disabled]="isLoading" data-toggle="modal" data-target="#staticBackdrop">
      Supprimer
    </button>-->
    <button type="submit" class="btn btn-info" [disabled]="!form.valid || form.pristine || isLoading || !codeValide">
      <span [style.display]="isLoading ? 'inline-block' : 'none'" class="fa fa-refresh spinning"></span>
      Sauvegarder
    </button>
    <button type="button" class="btn btn-default" [disabled]="isLoading" (click)="cancel()">Annuler</button>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="staticBackdropLabel">Suppression de la comp&eacute;tence</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          Attention! Cette action est irr&eacute;versible...
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" (click)="supprimer()">Supprimer</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
        </div>
      </div>
    </div>
  </div>


</form>
